<template>
	<div class="qualification-maintenance">
		<!-- 资质提醒--start -->
		<div class="maintenance-container">
			<div class="maintenance-content">
				<div class="tab-container">
					<!-- tab切换区域--start -->
					<div class="cjt-tabs">
						<div class="cjt-tabs__header">
							<div class="cjt-tabs__nav-wrap">
								<div
									v-for="(tab, index) in maintenanceTabs"
									:key="index"
									class="cjt-tabs__item"
									:class="{ active: activeTabIndex === index }"
									@click="changeMaintenanceTab(index)"
								>
									<span class="cjt-tabs__item-text">{{ tab.name }}</span>
									<span v-if="tab.count > 0" class="cjt-tabs__item-badge">{{ tab.count }}</span>
								</div>

								<!-- <div class="cjt-tabs-more">
									<router-link to="#">
										更多
										<i class="el-icon-arrow-right"></i>
									</router-link>
								</div> -->
							</div>
						</div>
						<div class="cjt-tabs__container">
							<!-- 内容区域 -->
							<transition name="fade-transform" mode="out-in">
								<div :key="activeTabIndex" class="cjt-tabs__content">
									<!-- 临期提醒内容 -->
									<div v-if="activeTabIndex === 0" v-loading="temporaryLogLoading" class="maintenance-list">
										<!-- 列表项 -->
										<template v-if="nearExpiryNotificationList.length">
											<div
												v-for="(item, index) in nearExpiryNotificationList"
												:key="index"
												class="notification-item"
												:class="{
													urgent: item.warningState === '1',
													warning: item.warningState === '2',
													notice: item.warningState === '3',
													normal: item.warningState === '4'
												}"
											>
												<div class="certificate-info">
													<div class="certificate-name">
														<div>
															<svg-icon icon-class="enterprise" class="certificate-icon"></svg-icon>
															<span :class="{ unread: !item.msgConsumeState }">{{ item.certName }}</span>
														</div>
													</div>
													<div class="certificate-detail">
														<div class="detail-item">
															<label>资质类别：</label>
															<span class="detail-content">
																{{ item.certInfo }}
															</span>
														</div>
														<div class="detail-item">
															<label>注册时间：</label>
															<span class="detail-content">{{ item.startTime }}</span>
														</div>
														<div class="detail-item">
															<label>有效时间：</label>
															<span class="detail-content">{{ item.expiredTime }}</span>
														</div>
													</div>
												</div>

												<div class="certificate-actions">
													<div class="action-buttons">
														<span
															class="action-btn"
															:class="{ unread: !item.msgConsumeState }"
															@click="handleToDiagnose('lq', item.id)"
														>
															立即诊断
														</span>
													</div>

													<div class="remainder">
														剩余时间
														<span class="remainder-num">{{ item.day }}</span>
														<span class="remainder-day">天</span>
													</div>
												</div>

												<div class="status-btn">
													{{ getStatusText(item.warningState) }}
												</div>
											</div>
										</template>
										<!-- 数据为空 -->
										<empty-content v-else></empty-content>
									</div>

									<!-- 其他Tab内容 -->
									<div v-if="activeTabIndex === 1" class="maintenance-list">
										<template v-if="companyWarning.zx.length">
											<div v-for="(item, index) in companyWarning.zx" :key="index" class="notification-item">
												<div class="certificate-info">
													<div class="certificate-name">
														<div class="certificate-notice">{{ item.waringInfo }}</div>
													</div>

													<div class="certificate-detail">
														<div class="detail-item">
															<label>预警时间：</label>
															<span class="detail-content">{{ item.createTime }}</span>
														</div>
													</div>
												</div>

												<div class="certificate-actions">
													<div class="action-buttons">
														<span
															class="action-btn"
															:class="{ unread: !item.msgConsumeState }"
															@click="handleToDiagnose('zx', item.id)"
														>
															立即诊断
														</span>
														<span
															class="action-btn"
															:class="{ unread: !item.msgConsumeState }"
															@click="handleToPersonDetail(item.businessId, item.id)"
														>
															详情
														</span>
													</div>
												</div>
											</div>

											<!-- 分页 -->
											<div v-if="warningPageOptions.zx.total > warningPageOptions.zx.limit" class="pagination-container">
												<jr-pagination
													:limit="warningPageOptions.zx.limit"
													:page.sync="warningPageOptions.zx.page"
													:total="warningPageOptions.zx.total"
													layout="prev, pager, next"
													prev-text="上一页"
													next-text="下一页"
													@change="pager => handleWarningPageChange(pager, 'zx')"
												></jr-pagination>
											</div>
										</template>

										<!-- 数据为空 -->
										<empty-content v-else></empty-content>
									</div>

									<div v-if="activeTabIndex === 2" class="maintenance-list">
										<template v-if="companyWarning.zc.length">
											<div v-for="(item, index) in companyWarning.zc" :key="index" class="notification-item">
												<div class="certificate-info">
													<div class="certificate-name">
														<div class="certificate-notice">{{ item.waringInfo }}</div>
													</div>

													<div class="certificate-detail">
														<div class="detail-item">
															<label>预警时间：</label>
															<span class="detail-content">{{ item.createTime }}</span>
														</div>
													</div>
												</div>

												<div class="certificate-actions">
													<div class="action-buttons">
														<span
															class="action-btn"
															:class="{ unread: !item.msgConsumeState }"
															@click="handleToDiagnose('zc', item.id)"
														>
															立即诊断
														</span>
														<span
															class="action-btn"
															:class="{ unread: !item.msgConsumeState }"
															@click="handleToPersonDetail(item.businessId, item.id)"
														>
															详情
														</span>
													</div>
												</div>
											</div>

											<!-- 分页 -->
											<div v-if="warningPageOptions.zc.total > warningPageOptions.zc.limit" class="pagination-container">
												<jr-pagination
													:limit="warningPageOptions.zc.limit"
													:page.sync="warningPageOptions.zc.page"
													:total="warningPageOptions.zc.total"
													layout="prev, pager, next"
													prev-text="上一页"
													next-text="下一页"
													@change="pager => handleWarningPageChange(pager, 'zc')"
												></jr-pagination>
											</div>
										</template>

										<!-- 数据为空 -->
										<empty-content v-else></empty-content>
									</div>

									<div v-if="activeTabIndex === 3" class="maintenance-list">
										<template v-if="companyWarning.fx.length">
											<div v-for="(item, index) in companyWarning.fx" :key="index" class="notification-item">
												<div class="certificate-info">
													<div class="certificate-name">
														<div class="certificate-notice">{{ item.waringInfo }}</div>
													</div>

													<div class="certificate-detail">
														<div class="detail-item">
															<label>预警时间：</label>
															<span class="detail-content">{{ item.createTime }}</span>
														</div>
													</div>
												</div>
												<div class="certificate-actions">
													<div class="action-buttons">
														<span
															class="action-btn"
															:class="{ unread: !item.msgConsumeState }"
															@click="handleToDiagnose('fx', item.id)"
														>
															立即诊断
														</span>
														<span
															class="action-btn"
															:class="{ unread: !item.msgConsumeState }"
															@click="handleViewRiskDetail(item)"
														>
															详情
														</span>
													</div>
												</div>
											</div>

											<!-- 分页 -->
											<div v-if="warningPageOptions.fx.total > warningPageOptions.fx.limit" class="pagination-container">
												<jr-pagination
													:limit="warningPageOptions.fx.limit"
													:page.sync="warningPageOptions.fx.page"
													:total="warningPageOptions.fx.total"
													layout="prev, pager, next"
													prev-text="上一页"
													next-text="下一页"
													@change="pager => handleWarningPageChange(pager, 'fx')"
												></jr-pagination>
											</div>
										</template>

										<!-- 数据为空 -->
										<empty-content v-else></empty-content>
									</div>
								</div>
							</transition>

							<!-- 未开通会员提示 -->
							<nonbind-vip v-if="isNormalVip"></nonbind-vip>
							<!-- 未绑定企业遮罩层 -->
							<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>
						</div>
					</div>
					<!-- tab切换区域--end -->
				</div>
			</div>
		</div>
		<!-- 资质提醒--end -->

		<!-- 资质预警维护--start -->
		<div class="warning-container">
			<div class="warning-content">
				<div class="moudleDefaultTitle">资质预警维护</div>

				<div class="warning-settings">
					<div class="section-sub-title">
						<h4>预警提示</h4>
					</div>

					<!-- 预警设置项 -->
					<div class="warning-items">
						<!-- 第一行，60-90天 -->
						<div class="warning-item">
							<div class="warning-range">60≤有效期≤90</div>
							<div class="warning-config">
								<div class="config-group">
									<el-select
										v-model="warningConfig.yellowWarningSms"
										size="small"
										placeholder="请选择"
										@change="handleWarningConfigChange"
									>
										<el-option label="一周" value="1"></el-option>
										<el-option label="二周" value="2"></el-option>
										<el-option label="三周" value="3"></el-option>
										<el-option label="四周" value="4"></el-option>
									</el-select>
									<span class="config-text">短信提醒一次</span>
								</div>
							</div>
						</div>

						<!-- 第二行，30-60天 -->
						<div class="warning-item">
							<div class="warning-range">30≤有效期&lt;60</div>
							<div class="warning-config">
								<div class="config-group">
									<el-select
										v-model="warningConfig.orangeWarningSms"
										size="small"
										placeholder="请选择"
										@change="handleWarningConfigChange"
									>
										<el-option label="一周" value="1"></el-option>
										<el-option label="二周" value="2"></el-option>
										<el-option label="三周" value="3"></el-option>
										<el-option label="四周" value="4"></el-option>
									</el-select>
									<span class="config-text">短信提醒一次</span>
								</div>
							</div>
						</div>

						<!-- 第三行，0-30天 -->
						<div class="warning-item">
							<div class="warning-range">0≤有效期&lt;30</div>
							<div class="warning-config">
								<div class="config-group">
									<el-select
										v-model="warningConfig.redWarningSms"
										size="small"
										placeholder="请选择"
										@change="handleWarningConfigChange"
									>
										<el-option label="一周" value="1"></el-option>
										<el-option label="二周" value="2"></el-option>
										<el-option label="三周" value="3"></el-option>
										<el-option label="四周" value="4"></el-option>
									</el-select>
									<span class="config-text">短信提醒一次</span>
								</div>
							</div>
						</div>

						<!-- 未绑定企业遮罩层 -->
						<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>
						<!-- 未开通会员提示 -->
						<nonbind-s-vip v-else-if="!isSVip"></nonbind-s-vip>
					</div>
				</div>
			</div>
		</div>
		<!-- 资质预警维护--end -->

		<!-- 当前资质预警委托--start -->
		<div class="current-warning-container">
			<div class="current-warning-content">
				<div class="section-sub-title">
					<h4>当前资质预警委托</h4>
				</div>

				<div class="warning-table-container">
					<div v-if="qualificationAlertList.length" class="current-warning-table">
						<table>
							<tr v-for="(item, index) in qualificationAlertList" :key="index">
								<th>{{ item.certName }}</th>
								<td>{{ item.certInfo }}</td>
							</tr>
						</table>
					</div>

					<!-- 空数据占位 -->
					<div v-else class="empty-wrapper">
						<div class="empty-content">
							<img src="@/assets/noInfo.png" alt="暂无信息" />
							<p>暂无资质预警委托</p>
							<span>您可以通过"前往管理"按钮添加需要预警的资质</span>
						</div>
					</div>

					<div class="current-warning-footer">
						<button class="cjt-button cjt-button--primary" type="button" @click="handleAlertInfoManage">前往管理</button>
					</div>

					<!-- 未绑定企业遮罩层 -->
					<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>
					<!-- 未开通会员提示 -->
					<nonbind-vip v-else-if="isNormalVip"></nonbind-vip>
				</div>
			</div>
		</div>
		<!-- 当前资质预警委托--end -->

		<!-- 现有资质--start -->
		<div class="current-qualification-container">
			<div class="current-qualification-content">
				<div class="moudleDefaultTitle">现有资质</div>

				<!-- 此区域下需要先判断是否绑定企业、再判断是否为高级会员 -->
				<div class="qualification-content-wrapper">
					<!-- 搜索区域 -->
					<div class="search-area">
						<div class="search-item">
							<label>证书类别</label>
							<el-select v-model="searchForm.certificateType" placeholder="全部" size="small">
								<el-option label="全部" value=""></el-option>
								<el-option
									v-for="(item, index) in certTypeDict"
									:key="index"
									:label="item.dictionaryValues"
									:value="item.dictcode"
								></el-option>
							</el-select>
						</div>

						<button class="cjt-button cjt-button--primary" type="button" @click="handleQueryCompanyCertificate">搜索</button>
					</div>

					<!-- 资质列表表格 -->
					<div class="qualification-table">
						<data-table
							:table-data="qualificationList"
							:column="qualificationColumns"
							:page-hide="false"
							:border="false"
							header-cell-class="th1"
							cell-class-name="cell1"
						></data-table>
					</div>

					<!-- 未绑定企业遮罩层 -->
					<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>
					<!-- 未开通会员提示 -->
					<!-- <nonbind-vip v-else-if="isNormalVip"></nonbind-vip> -->
				</div>
			</div>
		</div>
		<!-- 现有资质--end -->

		<!-- 资质材料维护--start -->
		<div class="material-maintenance-container">
			<div class="material-maintenance-content">
				<div class="moudleDefaultTitle">资质材料维护</div>

				<div class="material-maintenance-box">
					<div class="section-sub-title">
						<h4>资质材料维护</h4>

						<!-- <div class="info" @click="handleOpenStaffLibrary">
							<i class="el-icon-user-solid"></i>
							<span>人员库</span>
						</div> -->
					</div>

					<div class="maintenance-tab">
						<div class="maintenance-tab-header">
							<el-tabs v-model="activeMaintenanceTabIndex" class="custom-tabs">
								<el-tab-pane
									v-for="(item, index) in itemApplyTypeList"
									:key="`tabPane-${index}`"
									:label="item.itemName"
									:name="item.itemCode"
								></el-tab-pane>
							</el-tabs>
						</div>
						<div class="maintenance-tab-content">
							<transition name="fade-transform" mode="out-in">
								<div :key="activeMaintenanceTabIndex">
									<!-- 工程监理 -->
									<div v-if="activeMaintenanceTabIndex === '106'">
										<engineering-supervision-maintenance></engineering-supervision-maintenance>
										<div v-if="isHasCompany && !isNormalVip" class="material-button">
											<button class="cjt-button cjt-button--primary" type="button" @click="handleMaintenanceTask('106')">
												前往维护
											</button>
										</div>
									</div>
									<!-- 建筑业 -->
									<div v-if="activeMaintenanceTabIndex === '107'">
										<construction-enterprise-maintenance></construction-enterprise-maintenance>
										<div v-if="isHasCompany && !isNormalVip" class="material-button">
											<button class="cjt-button cjt-button--primary" type="button" @click="handleMaintenanceTask('107')">
												前往维护
											</button>
										</div>
									</div>
									<!-- 安许 -->
									<div v-if="activeMaintenanceTabIndex === '109'">
										<safety-permit-maintenance></safety-permit-maintenance>

										<div v-if="isHasCompany && !isNormalVip" class="material-button">
											<button class="cjt-button cjt-button--primary" type="button" @click="handleMaintenanceTask('109')">
												前往维护
											</button>
										</div>
									</div>
									<!-- 工程监理 -->
									<div v-if="activeMaintenanceTabIndex === '111'">
										<real-estate-development-maintenance></real-estate-development-maintenance>
										<div v-if="isHasCompany && !isNormalVip" class="material-button">
											<button class="cjt-button cjt-button--primary" type="button" @click="handleMaintenanceTask('111')">
												前往维护
											</button>
										</div>
									</div>
								</div>
							</transition>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 资质材料维护--end -->

		<jr-dialog
			:visible.sync="qualificationVisible"
			title="选择资质"
			width="1400px"
			top="100px"
			:append-to-body="true"
			@confirm="handleSaveAlertInfo"
			@cancel="handleCancelAlertInfo"
		>
			<template v-if="qualificationVisible" slot="content">
				<data-table
					ref="qualificationTable"
					:table-data="qualificationAllList"
					:column="qualificationColumns"
					:page-hide="false"
					:border="false"
					header-cell-class="th1"
					cell-class-name="cell1"
					index="true"
					:selection="true"
					:reserve-selection="true"
					:row-keys="handleRowKeys"
					@selectionChange="handleQualificationSelect"
				></data-table>
			</template>
		</jr-dialog>

		<!-- 人员库 -->
		<jr-dialog
			:visible.sync="staffLibraryVisible"
			title="人员库"
			width="70%"
			top="100px"
			:append-to-body="true"
			:show-btn="false"
		>
			<template v-if="staffLibraryVisible" slot="content">
				<staff-library></staff-library>
			</template>
		</jr-dialog>

		<!-- 风险提醒弹窗 -->
		<jr-dialog :visible.sync="riskVisible" :title="riskTitle" width="1400px" :append-to-body="true" :show-btn="false">
			<template v-if="riskVisible" slot="content">
				<component :is="getRiskComponentByType" :id="riskId" ref="riskComponent" :is-risk="true"></component>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import DataTable from '@/components/JrTable/DataTable.vue'
	import JrPagination from '@/components/Pagination'
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSVip from '@/components/NonBind/nonbindSVip.vue'
	import NonbindEnterprise from '@/components/NonBind/nonbindEnterprise'
	import StaffLibrary from './components/staffLibrary.vue'
	import SafetyPermitMaintenance from './materialsRecord/safetyPermitMaintenance.vue'
	import ConstructionEnterpriseMaintenance from './materialsRecord/constructionEnterpriseMaintenance'
	import EngineeringSupervisionMaintenance from './materialsRecord/engineeringSupervisionMaintenance'
	import RealEstateDevelopmentMaintenance from './materialsRecord/realEstateDevelopmentMaintenance'

	// 人员不良行为详情
	import BadBehaviorDetail from '../qualificationQuery/components/person/badBehaviorDetail.vue'
	// 人员处罚详情
	import PunishmentDetail from '../qualificationQuery/components/person/punishmentDetail.vue'
	// 人员黑名单详情
	import BlacklistRecordsDetail from '../qualificationQuery/components/person/blacklistRecordsDetail.vue'
	// 人员黑名单联合及惩戒
	import BlacklistPunishment from '../qualificationQuery/components/person/blacklistPunishment.vue'
	// 企业不良行为详情
	import BadCompanyBehaviorDetail from '../qualificationQuery/components/company/companyBehaviorDetail.vue'
	// 企业行政处罚详情
	import PunishmentCompanyDetail from '../qualificationQuery/components/company/punishmentCompanyDetail.vue'
	//企业 黑名单记录详情
	import blackListCompanyDetail from '../qualificationQuery/components/company/blackListCompanyDetail.vue'
	// 企业失信及联合惩戒记录
	import PunishDishonestyDetail from '../qualificationQuery/components/company/punishDishonestyDetail.vue'

	import {
		companyCertificateAllList,
		queryAlertMessageRules,
		saveOrUpdateAlertMessageRules,
		queryQualificationAlert,
		saveQualificationAlert,
		queryTemporaryLog,
		queryCompanyWarnginList,
		queryUnreadTemporaryLogCount,
		readTemporaryLog,
		queryUnreadCompanyWarnginListCount,
		readCompanyWarngin
	} from '@/api/certTreasure/qualificationAlert'
	import { mapGetters } from 'vuex'
	import { mapDictionaries } from '@/store/dictionary-helper'

	// 资质维护
	export default {
		name: 'QualificationMaintenance',
		components: {
			JrDialog,
			DataTable,
			JrPagination,
			NonbindVip,
			NonbindSVip,
			NonbindEnterprise,
			StaffLibrary,
			SafetyPermitMaintenance,
			ConstructionEnterpriseMaintenance,
			EngineeringSupervisionMaintenance,
			RealEstateDevelopmentMaintenance,
			BadBehaviorDetail,
			PunishmentDetail,
			BadCompanyBehaviorDetail,
			PunishmentCompanyDetail,
			BlacklistRecordsDetail,
			BlacklistPunishment,
			blackListCompanyDetail,
			PunishDishonestyDetail
		},
		props: {},
		data() {
			return {
				// 资质维护Tab数据
				activeTabIndex: 0,
				maintenanceTabs: [
					{ name: '临期提醒', type: 'lq', count: 0 },
					{ name: '注销提醒', type: 'zx', count: 0 },
					{ name: '注册提醒', type: 'zc', count: 0 },
					{ name: '风险提醒', type: 'fx', count: 0 }
				],

				temporaryLogLoading: false,
				// 临期提醒
				nearExpiryNotificationList: [],

				// 企业提醒
				companyWarning: {
					// 注销
					zx: [],
					// 注册
					zc: [],
					// 风险
					fx: []
				},

				// 分页配置（每种类型提醒单独控制）
				warningPageOptions: {
					zx: { page: 1, limit: 5, total: 0 },
					zc: { page: 1, limit: 5, total: 0 },
					fx: { page: 1, limit: 5, total: 0 }
				},

				// 各类提醒加载状态
				loadingStatus: {
					zx: false,
					zc: false,
					fx: false
				},

				riskVisible: false,
				// 查看哪一类风险信息
				riskType: '',
				// 标题
				riskTitle: '',
				// 当前查看的风险id
				riskId: '',

				// 预警配置数据
				warningConfig: {
					// 预警提醒规则主键id
					id: '',
					// 60天-90天预警平台提醒规则
					yellowWarningSms: '',
					// 30天-60天预警平台提醒规则
					orangeWarningSms: '',
					// "0天-30天预警短信提醒规则
					redWarningSms: ''
				},

				// 当前用户企业对应的预警委托信息
				qualificationAlertList: [],

				// 资质选择弹窗
				qualificationVisible: false,
				// 当前用户对应的所有证书资质
				qualificationAllList: [],
				qualificationColumns: [
					{ label: '证书类别', prop: 'certName', align: 'center' },
					{ label: '证书号', prop: 'certCode', align: 'center' },
					{ label: '资质名称', prop: 'zzmc', align: 'center' },
					{ label: '发证日期', prop: 'makeTime', align: 'center' },
					{ label: '发证有效期', prop: 'endTime', align: 'center' },
					{ label: '发证机关', prop: 'makeUnit', align: 'center' }
				],

				// 资质预警委托选择的证书id
				qualificationAlertIdArray: [],

				// 搜索表单
				searchForm: {
					certificateType: ''
				},

				// 资质列表数据
				qualificationList: [],
				pageOptions: {
					currentPage: 1,
					limit: 10,
					total: 0
				},

				// 人员库弹窗
				staffLibraryVisible: false,

				// 是否显示更多字段
				showMoreFields: false,
				// 添加当前激活的tab索引
				activeMaintenanceTabIndex: '109',
				// 所有证书类别
				itemApplyTypeList: [
					{
						itemName: '建筑施工企业安全生产许可证',
						itemCode: '109'
					},
					{
						itemName: '工程监理企业资质',
						itemCode: '106'
					},
					{
						itemName: '房地产开发企业资质',
						itemCode: '111'
					},
					{
						itemName: '建筑业企业资质',
						itemCode: '107'
					}
				]
			}
		},
		computed: {
			...mapGetters(['isHasCompany', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			// 使用自定义的映射函数
			...mapDictionaries('dictionary', ['certTypeDict', 'educationDict']),
			// 企业风险提醒详情查看组件计算
			getRiskComponentByType() {
				// 组件映射表
				const componentMap = {
					// 人员不良行为
					person_blxw: 'badBehaviorDetail',
					// 人员行政处罚
					person_xzcf: 'PunishmentDetail',
					// 人员黑名单记录
					person_hmd: 'BlacklistRecordsDetail',
					// 黑名单及联合惩戒详情
					person_lhcj: 'BlacklistPunishment',
					// 企业不良行为
					company_blxw: 'BadCompanyBehaviorDetail',
					// 企业行政处罚
					company_xzcf: 'PunishmentCompanyDetail',
					// 企业黑名单记录
					company_hmd: 'blackListCompanyDetail',
					// 企业黑名单及联合惩戒
					company_lhcj: 'PunishDishonestyDetail'
				}

				// 根据riskType获取对应的组件名
				return componentMap[this.riskType] || ''
			}
		},
		watch: {},
		created() {},
		mounted() {
			// 已绑定企业，并且成为了vip或者svip
			if (this.isHasCompany && (this.isVip || this.isSVip)) {
				this.handleQueryCertTemporaryLog()
				this.fetchAllWarningList()
				this.handleQueryAlertMessageRules()
				this.handleQueryAlertMessage()
			}
			if (this.isHasCompany) {
				this.handleQueryCompanyCertificate()
			}
		},
		methods: {
			// 切换Tab
			changeMaintenanceTab(index) {
				this.activeTabIndex = index
			},

			// 根据类型获取状态文本
			getStatusText(type) {
				const statusMap = {
					'1': '紧急提示',
					'2': '紧急提示',
					'3': '友情提示',
					'4': '友情提示'
				}
				return statusMap[type] || '普通提示'
			},

			// 临期提醒跳转延续诊断页面
			handleToDiagnose(flag, id) {
				if (flag === 'lq') {
					readTemporaryLog({ id })
				} else {
					readCompanyWarngin({ id })
				}

				this.$router.push({
					path: '/qualification/renewal'
				})
			},

			// 跳转到资质查人员详情页面
			handleToPersonDetail(personId, id) {
				readCompanyWarngin({ id }).then(res => {
					this.fetchAllWarningList()
				})

				// 生成完整的url
				const route = this.$router.resolve({
					path: '/qualification-query/personDetail',
					query: {
						id: personId // 传递详情ID参数
					}
				})
				window.open(route.href, '_blank')
			},

			// 打开企业风险提醒详情页面弹窗
			handleViewRiskDetail(risk) {
				const { businessId, businessType, id } = risk
				readCompanyWarngin({ id }).then(res => {
					this.fetchAllWarningList()
				})
				this.riskId = businessId
				this.riskType = businessType
				this.riskTitle = ''
				this.riskVisible = true
			},

			// 查询该用户委托证书的临期提醒信息
			handleQueryCertTemporaryLog() {
				this.nearExpiryNotificationList = []
				this.temporaryLogLoading = true
				queryTemporaryLog()
					.then(response => {
						this.temporaryLogLoading = false
						const { data } = response
						if (data && data.length) {
							this.nearExpiryNotificationList = data
							// this.maintenanceTabs[0].count = data.length
						}
					})
					.catch(error => {
						this.temporaryLogLoading = false
					})
				queryUnreadTemporaryLogCount().then(response => {
					const { data } = response
					this.maintenanceTabs[0].count = data
				})
			},

			// 查询所有类型的提醒列表（注销zx、注册zc、风险fx）
			fetchAllWarningList() {
				Object.keys(this.companyWarning).forEach(item => {
					this.fetchWarningList(item)
				})
			},

			// 查询企业提醒列表
			fetchWarningList(type) {
				this.loadingStatus[type] = true

				const params = {
					page: this.warningPageOptions[type].page,
					size: this.warningPageOptions[type].limit,
					waringType: type
				}

				queryCompanyWarnginList(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.companyWarning[type] = data.records
							this.warningPageOptions[type].total = data.total
							// this.maintenanceTabs.find(item => item.type === type).count = data.total
						} else {
							this.companyWarning[type] = []
							this.warningPageOptions[type] = 0
						}

						this.loadingStatus[type] = false
					})
					.catch(error => {
						this.companyWarning[type] = []
						this.warningPageOptions[type].total = 0
						this.loadingStatus[type] = false
					})
				// 查询未读数量
				queryUnreadCompanyWarnginListCount({ waringType: type }).then(response => {
					const { data } = response
					this.maintenanceTabs.find(item => item.type === type).count = data
				})
			},

			// 企业提醒列表分页
			handleWarningPageChange(pager, type) {
				this.warningPageOptions[type].page = pager.page
				this.warningPageOptions[type].limit = pager.limit
				this.fetchWarningList(type)
			},

			// 查询该用户绑定的企业的企业资质证书信息
			handleQueryCompanyCertificate() {
				const params = {
					zslx: this.searchForm.certificateType
				}
				companyCertificateAllList(params).then(response => {
					const { data } = response

					if (data && data.length) {
						this.qualificationList = data
						this.qualificationAllList = data
					} else {
						this.qualificationList = []
						this.qualificationAllList = []
					}
				})
			},

			// 查询预警提醒规则
			handleQueryAlertMessageRules() {
				queryAlertMessageRules().then(response => {
					const { data } = response

					if (data) {
						this.warningConfig.id = data.id
						this.warningConfig.yellowWarningSms = data.yellowWarningSms
						this.warningConfig.orangeWarningSms = data.orangeWarningSms
						this.warningConfig.redWarningSms = data.redWarningSms
					}
				})
			},

			// 预警规则变化，当某一项变化时进行存储
			handleWarningConfigChange() {
				const data = {
					...this.warningConfig
				}

				// svip才能够进行配置
				if (!this.isSVip) {
					return
				}

				saveOrUpdateAlertMessageRules(data)
			},

			// 查询本企业对应的预警委托信息
			handleQueryAlertMessage() {
				queryQualificationAlert().then(response => {
					const { data } = response
					if (data && data.length) {
						this.qualificationAlertList = data
					} else {
						this.qualificationAlertList = []
					}
				})
			},

			// 资质预警委托管理
			handleAlertInfoManage() {
				this.qualificationVisible = true
				// 若已有预警委托信息，则在table中进行回显处理
				if (this.qualificationAlertList.length > 0) {
					this.$nextTick(() => {
						this.qualificationList.forEach(item => {
							this.qualificationAlertList.forEach(item1 => {
								if (item1.certId === item.id) {
									this.$nextTick(() => {
										this.$refs.qualificationTable.$refs.dataTable.toggleRowSelection(item, true)
									})
								}
							})
						})
					})
				}
			},

			// 资质预警管理选择回调
			handleQualificationSelect(selection) {
				console.log('selection:', selection)
				this.qualificationAlertIdArray = selection.map(item => item.id)
				console.log('qualificationAlertIdArray:', this.qualificationAlertIdArray)
			},

			// 保存资质预警委托证书信息
			handleSaveAlertInfo() {
				const data = {
					id: this.qualificationAlertIdArray.join(',')
				}

				saveQualificationAlert(data).then(response => {
					const { code, message } = response
					if (code === 200) {
						this.$modal.msgSuccess('操作成功')
						this.handleQueryAlertMessage()
						// 查询一次临期提醒，查询加入委托预警的证书是否有即将过期的数据
						this.handleQueryCertTemporaryLog()
						this.qualificationVisible = false
					} else {
						// 这里做未开通会员、或者会员到期、或者超出该会员权益次数限制的提示
						this.$modal.msgWarning(message)
					}
				})
			},

			// 关闭资质预警委托证书信息
			handleCancelAlertInfo() {
				this.qualificationVisible = false
			},

			handleRowKeys(row) {
				return row.id
			},

			// 打开企业人员库
			handleOpenStaffLibrary() {
				this.staffLibraryVisible = true
			},

			// 切换显示更多字段
			toggleMoreFields() {
				this.showMoreFields = !this.showMoreFields
			},

			// 前往维护资质材料
			handleMaintenanceTask(code) {
				this.$router.push({
					path: `/qualification/maintenance-detail/${code}`
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';

	.qualification-maintenance {
		// 资质提醒
		.maintenance-container {
			background-color: #f5f9fb;
			padding: 20px 0;

			.maintenance-content {
				width: $main-page-width;
				margin: 0 auto;

				.tab-container {
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
					border-radius: 6px;
				}
			}

			// 改写提醒列表部分样式
			.maintenance-list {
				.notification-item {
					.certificate-info {
						flex: 1;
					}

					.certificate-actions {
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						align-items: baseline;
						margin-right: 15px;
						// min-width: 240px;
						margin-left: 20px;

						.action-buttons {
							display: flex;

							.action-btn {
								margin-left: 10px;
								font-size: 16px;
								color: #2671cb;
								cursor: pointer;
							}
						}
					}

					.remainder {
						width: 140px;
						margin-top: 30px;
						margin-left: 25px;
					}
				}
			}
		}

		// 资质预警维护
		.warning-container {
			background-color: #f5f9fb;
			padding: 20px 0;
			.warning-content {
				width: $main-page-width;
				margin: 0 auto;
				.warning-settings {
					margin-top: 10px;
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
					border-radius: 6px;

					.warning-items {
						position: relative;
						.warning-item {
							display: flex;
							align-items: center;
							margin-bottom: 20px;

							&:last-child {
								margin-bottom: 0;
							}

							.warning-range {
								width: 200px;
								font-size: 16px;
								text-align: center;
								color: #333333;
							}

							.warning-config {
								flex: 1;
								display: flex;

								.config-group {
									display: flex;
									align-items: center;
									margin-right: 30px;

									.el-select {
										width: 120px;
									}

									.config-text {
										margin-left: 10px;
										font-size: 16px;
										color: #333333;
									}
								}
							}
						}
					}
				}
			}
		}

		// 当前资质预警委托
		.current-warning-container {
			background-color: #f5f9fb;
			padding: 20px 0;

			.current-warning-content {
				width: $main-page-width;
				margin: 0 auto;
				padding: 20px;
				background-color: #ffffff;
				box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
				border-radius: 6px;

				.warning-table-container {
					position: relative;
				}

				.current-warning-table {
					padding: 20px 40px;
					background-color: #fff;
					border-radius: 6px;
					overflow: hidden;

					table {
						width: 100%;
						border-collapse: separate;
						border-spacing: 0;
						border: 1px solid #c9c9c9;
						border-radius: 6px;
						overflow: hidden;

						box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
						transition: all 0.3s ease;

						&:hover {
							box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
						}

						tr {
							transition: background-color 0.2s ease;

							&:hover {
								background-color: #f5faff;
							}

							&:last-child {
								border-bottom: none;
							}
						}

						th,
						td {
							padding: 15px 20px;
							text-align: left;
							font-size: 16px;
							border-bottom: 1px solid #c9c9c9;
						}

						tr:last-child {
							th,
							td {
								border-bottom: none;
							}
						}

						th {
							width: 200px;
							background-color: #e8f4f9;
							color: #333333;
							font-weight: 500;
							text-align: center;
							border-right: 1px solid #c9c9c9;
						}

						td {
							color: #333333;
							line-height: 1.6;
						}
					}
				}

				.current-warning-footer {
					margin-top: 20px;
					text-align: center;
				}
			}
		}

		// 现有资质
		.current-qualification-container {
			padding: 20px;
			background-color: #f5f9fb;

			.current-qualification-content {
				width: $main-page-width;
				margin: 0 auto;

				.qualification-content-wrapper {
					position: relative;
					// 未绑定企业遮罩层
					.non-company-mask {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						background-color: rgba(255, 255, 255, 0.9);
						display: flex;
						justify-content: center;
						align-items: center;
						z-index: 10;
						border-radius: 6px;
						backdrop-filter: blur(2px);
						box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);

						.mask-content {
							min-width: 400px;
							height: 59px;
							background-image: linear-gradient(90deg, #ffe8b6 0%, #fff4db 100%);
							border-radius: 10px;
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							display: flex;
							justify-content: space-between;
							align-items: center;
							padding: 0px 16px;
							img {
								width: 47px;
								height: 37px;
							}
							p {
								font-size: 20px;
								color: #934e25;
								font-weight: bold;
								margin-left: 20px;
							}
							a {
								font-size: 18px;
								color: #ff670d;
								margin-left: 20px;
							}
						}
					}
				}

				// 搜索区域
				.search-area {
					display: flex;
					justify-content: left;
					align-items: center;
					padding: 15px 20px;

					.search-item {
						display: flex;
						align-items: center;
						margin-right: 20px;

						label {
							margin-right: 10px;
							color: #333;
							font-size: 18px;
						}

						.el-select,
						.el-input {
							width: 200px;

							::v-deep .el-input__inner {
								height: 40px;
								line-height: 40px;
							}
						}
					}
				}

				// 资质列表表格
				.qualification-table {
					background-color: #fff;
					padding: 10px;
					border-radius: 4px;
					box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
					margin-bottom: 20px;
				}
			}
		}

		// 资质材料维护
		.material-maintenance-container {
			background-color: #f5f9fb;
			padding: 20px 0 40px;

			.material-maintenance-content {
				width: $main-page-width;
				margin: 0 auto;

				.material-maintenance-box {
					margin-top: 10px;
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
					border-radius: 6px;

					.section-sub-title {
						margin-bottom: 10px;

						// 增加标题右方展示的提示
						.info {
							display: flex;
							align-items: center;
							font-size: 16px;
							color: #333333;
							background-color: #ffffff;
							border-radius: 20px;
							// border: solid 1px #3e6ea9;
							padding: 2px 20px;
							margin: 2px 0;
							cursor: pointer;

							i {
								color: #1890ff;
								margin-right: 5px;
							}

							:hover {
								color: #236fca;
							}
						}
					}

					.maintenance-tab {
						padding: 0 10px;
					}

					.material-table {
						padding: 10px;
						background-color: #fff;
						border-radius: 6px;
						overflow: hidden;

						table {
							width: 100%;
							border-collapse: separate;
							border-spacing: 0;
							border: 1px solid #c9c9c9;
							border-radius: 6px;
							background-color: #ffffff;
							overflow: hidden;

							&:not(:last-child) {
								border-bottom-left-radius: 0;
								border-bottom-right-radius: 0;
							}

							tr {
								&:not(:last-child) {
									border-bottom: 1px solid #c9c9c9;
								}
							}

							th,
							td {
								padding: 15px 20px;
								text-align: left;
								font-size: 16px;
								border-bottom: 1px solid #c9c9c9;
							}

							tr:last-child {
								th,
								td {
									border-bottom: none;
								}
							}

							th {
								width: 180px;
								background-color: #e8f4f9;
								color: #333;
								font-weight: 500;
								border-right: 1px solid #c9c9c9;
							}

							td {
								width: calc(50% - 180px);
								color: #666;
								line-height: 1.6;

								&:not(:last-child) {
									border-right: 1px solid #c9c9c9;
								}
							}
						}

						.expand-more {
							text-align: center;
							padding: 10px 0;
							color: #4686d2;
							cursor: pointer;
							transition: all 0.3s;
							background-color: #ffffff;
							border: 1px solid #c9c9c9;
							border-top: none;
							border-bottom-left-radius: 6px;
							border-bottom-right-radius: 6px;

							&:hover {
								background-color: #e8f4f9;
							}

							span {
								margin-right: 5px;
							}
						}

						.more-fields {
							margin-top: -4px;

							table {
								border-top-left-radius: 0;
								border-top-right-radius: 0;
							}
						}
					}

					.material-button {
						margin-top: 20px;
						text-align: center;
					}

					.material-footer {
						margin-top: 20px;
						text-align: center;
					}
				}
			}
		}
	}

	// 添加过渡动画
	.slide-fade-enter-active {
		transition: all 0.3s ease-out;
	}
	.slide-fade-leave-active {
		transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
	}
	.slide-fade-enter,
	.slide-fade-leave-to {
		transform: translateY(-20px);
		opacity: 0;
	}
	.unread {
		color: #ff4d4f !important; // 未读标识颜色
	}
</style>
